<template>
<div class="template-page" v-html="template.html">
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { renderChart } from '@/utils/helpers.js'

export default {
	computed: {
		...mapState({
			template: ({ TemplateStore }) => TemplateStore.template,
			opportunity: ({ OpportunityStore }) => OpportunityStore.opportunity
		})
	},
	created() {
		this.getOpportunity({
			opportunityId: 1
		})
		this.getTemplate().then(() => {
			this.setStyle()
			let chartList = Array.from(document.getElementsByClassName('myChart'))
			chartList.map(element => {
				renderChart(element, this.opportunity.chart_data)
			})
		})
	},
	methods: {
		...mapActions({
			getTemplate: 'TemplateStore/getTemplate',
			getOpportunity: 'OpportunityStore/getOpportunity'
		}),
		setStyle() {
			let head = document.head || document.getElementsByTagName('head')[0]
			let style = document.createElement('style')
			style.id = 'template-page-style'

			head.appendChild(style)

			style.type = 'text/css'
			if(style.styleSheet) {
				style.styleSheet.cssText = this.template.css
			} else {
				style.appendChild(document.createTextNode(this.template.css))
			}
		}
	},
	destroyed() {
		let style = document.getElementById('template-page-style')
		style.remove()
	}
}
</script>

<style>

</style>
